import { __ } from '@wordpress/i18n';
import arrow from './arrows';

export const titleTag = [
    { label: __('H1', 'slider'), value: 'h1' },
    { label: __('H2', 'slider'), value: 'h2' },
    { label: __('H3', 'slider'), value: 'h3' },
    { label: __('H4', 'slider'), value: 'h4' },
    { label: __('H5', 'slider'), value: 'h5' },
    { label: __('H6', 'slider'), value: 'h6' },
    { label: __('P', 'slider'), value: 'p' },
    { label: __('Div', 'slider'), value: 'div' }
]

export const indicatorOptions = [
    { label: __('Horizontal', 'slider'), value: 'horizontal' },
    { label: __('Vertical', 'slider'), value: 'vertical' },
]

export const arrowStyles = [
    { label: __('Style 1', 'slider'), value: 'style1', icon: arrow['style1'].right() },
    { label: __('Style 2', 'slider'), value: 'style2', icon: arrow['style2'].right() },
    { label: __('Style 3', 'slider'), value: 'style3', icon: arrow['style3'].right() },
    { label: __('Style 4', 'slider'), value: 'style4', icon: arrow['style4'].right() },
    { label: __('Style 5', 'slider'), value: 'style5', icon: arrow['style5'].right() },
    { label: __('Style 6', 'slider'), value: 'style6', icon: arrow['style6'].right() },
]

export const contentPosition = [
    { label: __('Bottom Center', 'slider'), value: 'bottom center' },
    { label: __('Center Center', 'slider'), value: 'center center' },
]

export const contentAniOption = [
    { label: __('Fade In Left', 'slider'), value: 'fadeInLeft' },
    { label: __('Fade In Right', 'slider'), value: 'fadeInRight' },
    { label: __('Fade In Up', 'slider'), value: 'fadeInUp' },
    { label: __('Fade In Down', 'slider'), value: 'fadeInDown' },
    { label: __('Fade In', 'slider'), value: 'fadeIn' },
    { label: __('Zoom In', 'slider'), value: 'zoomIn' },
    { label: __('Slide In Down', 'slider'), value: 'slideInDown' },
    { label: __('Slide In Up', 'slider'), value: 'slideInUp' },
    { label: __('Slide In Left', 'slider'), value: 'slideInLeft' },
    { label: __('Slide In Right', 'slider'), value: 'slideInRight' },
]

export const animationOptions = [
    { label: __('Default', 'slider'), value: 'default' },
    { label: __('Fade', 'slider'), value: 'carousel-fade' },
    { label: __('Flip', 'slider'), value: 'flip' },
]

export const animationFreeOptions = [
    { label: __('Default', 'slider'), value: 'default' },
    { label: __('Fade', 'slider'), value: 'carousel-fade' }
];

export const sliderOption = [
    { label: __('Default', 'slider'), value: 'default' },
    { label: __('Vertical', 'slider'), value: 'vertical' },
]

export const indicatorOption = [
    { label: __('Default', 'slider'), value: 'default' },
    { label: __('Image', 'slider'), value: 'image' }
];

export const tabs = [
    {
        name: 'General',
        title: __('General', 'slider'),
        className: 'general',
    },
    {
        name: 'style',
        title: __('Style', 'slider'),
        className: 'style',
    },
    {
        name: 'patterns',
        title: __('Patterns', 'slider'),
        className: 'patterns',
    }
];

export const visibility = [
    { label: __('Show', 'slider'), value: 'true' },
    { label: __('Hide', 'slider'), value: 'false' },
]

export const styles = [
    { label: __('Default', 'slider'), value: '' },
    { label: __('Dot', 'slider'), value: 'dot' },
];

export const pxUnit = (def = 0) => ({ value: 'px', label: 'px', default: def });
export const perUnit = (def = 0) => ({ value: '%', label: '%', default: def });
export const emUnit = (def = 0) => ({ value: 'em', label: 'em', default: def });
export const remUnit = (def = 0) => ({ value: 'rem', label: 'rem', default: def });
export const vwUnit = (def = 0) => ({ value: 'vw', label: 'vw', default: def });
export const vhUnit = (def = 0) => ({ value: 'vh', label: 'vh', default: def });
